import { render, staticRenderFns } from "./ChatOnFaith.vue?vue&type=template&id=820b3dc8&scoped=true&"
import script from "./ChatOnFaith.vue?vue&type=script&lang=js&"
export * from "./ChatOnFaith.vue?vue&type=script&lang=js&"
import style0 from "./ChatOnFaith.vue?vue&type=style&index=0&id=820b3dc8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820b3dc8",
  null
  
)

export default component.exports